import React from 'react';
import { WebAssetEditPage } from 'signoxe/containers';

const DataAssetEditPage = (props) => {
  return <WebAssetEditPage {...props} dataAsset/>;
};

export default DataAssetEditPage;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/DataAssetEditPage/index.js